<div class="content">
  <h2 *ngIf="title" class="content__title">{{ title }}</h2>

  <dgx-components-rich-text
    *ngIf="body"
    [content]="body"
    class="content__body"
  />
</div>

<ul class="video-list mt-4">
  <li
    *ngFor="let video of videos"
    class="video-list__item mb-4"
    data-testid="video-list"
    tabindex="0"
    (keydown.enter)="onClick(articleNavigation, video)"
  >
    <a
      [dgxNavigationLink]="video.navigationLink"
      class="video-list__video-link video-embed-link"
      tabindex="-1"
      #articleNavigation
      (click)="onClick(articleNavigation, video)"
      aria-label="article-link"
    >
      <dgx-components-youtube-player
        [video]="{
          id: video.videoId,
        }"
        class="video-list__video"
      ></dgx-components-youtube-player>
    </a>
    <dgx-components-youtube-player
      [video]="{
        id: video.videoId,
      }"
      class="video-list__video video-embed-player"
    ></dgx-components-youtube-player>
    <div class="video-list__content">
      <div class="video-list__content-wrapper">
        <a
          class="video-list__video-link"
          tabindex="-1"
          (click)="onClick(articleNavigation, video)"
        >
          <h5 class="video-list__content-title">
            {{ video.title }}
          </h5>
        </a>
        <a
          [dgxNavigationLink]="video.navigationLink"
          class="video-list__video-link"
          tabindex="-1"
        >
          <p class="body" [innerHtml]="video.body"></p>
        </a>
      </div>
    </div>
  </li>
</ul>
